import {NullParser} from './null-parser'
import {STLParser} from './stl-parser'

class UnsupportedObjectError extends Error {}

const parserByExtension = {
  stl: STLParser,
}

export const getRenderableParser = (url = '') => {
  // If we're asked to load literally nothing, we'll
  // go ahead and do that.
  if (!url || url.trim() === '') {
    return new NullParser()
  }

  const [file] = url.split('?')
  const result = (file || '').match(/\.([^.]*)$/)

  if (result.length > 0) {
    const ext = (result[1] || '').toLowerCase()
    const Parser = parserByExtension[ext]
    if (Parser) {
      return new Parser()
    }
  }

  // We cant find a loader, so exploooode
  throw new UnsupportedObjectError(`No fitting loader for url [${url}]`)
}
